import { useContext, useEffect } from "react";
import { SuccessIcon } from "./Icons";
import { ErrorIcon } from "./Icons";
import { FieldProps, StateContextType } from "../../types";
import { validators } from "../../languages";
import InputControl from "./InputControl";
import MainStateContext from "../../state/mainStateContext";

export function PostalCodeField(props: FieldProps) {
  const { formMethods, fieldClasses, inputWrapperClasses, inputClasses, disabled } = props;
  const { setValueChange } = formMethods;
  const { state } = useContext(MainStateContext) as StateContextType;
  const { address } = state;

  useEffect(() => {
    setValueChange("postcode", address.zip);
  }, [address.zip]);

  return (
    <InputControl
      fieldId="postcode"
      fieldName="postcode"
      fieldTitlePhraseKey="payment_step.field_labels.zip"
      fieldType="tel"
      fieldValue={address.zip}
      fieldClasses={fieldClasses}
      inputWrapperClasses={inputWrapperClasses}
      inputClasses={inputClasses}
      labelClasses={"is-required sr-only"}
      formMethods={formMethods}
      attributes={{
        disabled: disabled,
        autoCorrect: "off",
        autoComplete: "postal-code",
        "data-lpignore": "true"
      }}
      errorIcon={<ErrorIcon />}
      successIcon={<SuccessIcon />}
      validators={[validators.required, validators.zip]}
    />
  );
}

export default PostalCodeField;
